import React, { useEffect, useState } from "react";
import { Modal, Input, Select } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import { ModalButton, TextButton } from "../baseComponents";
import { analyticsInstance } from "../../analytics/analyticsCtrls";

export const CreateProject = observer(() => {
  const {
    uiStore: { createProjectModalVisible, setCreateProjectModalHidden },
    projectStore: { createNewProject },
    authStore: { getGroupIds },
  } = useMst();
  useEffect(() => {
    const getGroups = async () => {
      const allGroups = await getGroupIds();
      setGroups(allGroups);
      setSelectedGroup(allGroups[0]);
    };
    getGroups();
  }, []);

  const [groups, setGroups] = useState<string[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<string>("");
  const [newProjectName, setNewProjectName] = useState("");
  const [processCreate, setProcessCreate] = useState(false);
  const handleCreateProject = async () => {
    if (newProjectName.length) {
      setProcessCreate(true);
      try {
        const id = await createNewProject(newProjectName, selectedGroup);
        analyticsInstance.sendAnalytics("project", {
          val: "create",
          account: selectedGroup,
          pId: id,
        });
      } catch (error) {
        console.log("Connection Offline");
      }
      setProcessCreate(false);
      setCreateProjectModalHidden();
    }
  };

  return (
    <Modal
      className={[styles.Modal, styles.NewProjectModal].join(" ")}
      visible={createProjectModalVisible}
      centered
      onOk={setCreateProjectModalHidden}
      onCancel={setCreateProjectModalHidden}
      footer={false}
    >
      <h1 className={styles.ModalHeader}>
        New Project
        {processCreate && ` ${newProjectName}`}
      </h1>
      <p className={styles.Extra}>Create a new project from scratch</p>
      <>
        <Input
          className={styles.Input}
          placeholder="Name your project"
          value={newProjectName}
          onChange={(e) => {
            const { value } = e.target;
            setNewProjectName(value);
          }}
          autoFocus
        />
        {groups.length > 1 ? (
          <Select
            placeholder="Select an Account"
            className={styles.Select}
            dropdownClassName="DropDown-Project"
            defaultValue={groups[0]}
            size="middle"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={groups
              .sort((a, b) => a.localeCompare(b))
              .map((group) => ({ label: group, value: group }))}
            onChange={(g) => setSelectedGroup(g)}
          />
        ) : (
          ""
        )}
        <div className={styles.Buttons}>
          <TextButton onClick={setCreateProjectModalHidden} text="Cancel" />
          <ModalButton
            onClick={handleCreateProject}
            disabled={newProjectName.length === 0 || processCreate}
            text={processCreate ? "Creating" : "Create"}
          />
        </div>
      </>
    </Modal>
  );
});
